import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  font-size: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 0.5rem;
  outline: none;
  width: 100%;
  background-color: var(--bg-input);
  color: var(--text-bright);

  &:focus {
    border-color: var(--primary-accent);
  }
`;

const Input = (props: React.InputHTMLAttributes<HTMLInputElement>) => <StyledInput {...props} />;

export default Input;

